// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
	font-family: inherit !important;
	text-decoration: inherit !important;
}

.Shared_container__W1B98 {
	padding: 10px 100px !important;
}

.Shared_parent__yPy3i {
	padding-top: 90px !important;
}

.Shared_window__2hIRZ {
	min-height: 100vh !important;
}

.Shared_p0__zxx2s {
	padding: 0 !important;
}

.Shared_m0__-P\\+BZ {
	margin: 0 !important;
}

.Shared_g0__Kx7-c {
	gap: 0 !important;
}

.Shared_p5__jCU7D {
	padding: 5px !important;
}

.Shared_m5__Nxq3r {
	margin: 5px !important;
}

.Shared_g5__UlPY5 {
	gap: 5px !important;
}

.Shared_p10__swOie {
	padding: 10px !important;
}

.Shared_pT70__H56L8 {
	padding-top: 70px !important;
}

.Shared_m10__P7A8Z {
	margin: 10px !important;
}

.Shared_mT70__IWcDj {
	margin-top: 70px !important;
}

.Shared_pT10__BnsvV {
	padding-top: 10px !important;
}

.Shared_mT10__zjjBt {
	margin-top: 10px !important;
}

.Shared_mT20__IfbQA {
	margin-top: 20px !important;
}

.Shared_pT5__v7BKz {
	padding-top: 5px !important;
}

.Shared_mT5__9GviX {
	margin-top: 5px !important;
}

.Shared_pB10__lfo0d {
	padding-bottom: 10px !important;
}

.Shared_mB10__SXkVD {
	margin-bottom: 10px !important;
}

.Shared_pB5__tbweH {
	padding-bottom: 5px !important;
}

.Shared_mB5__jMOZ1 {
	margin-bottom: 5px !important;
}

.Shared_pL10__nHCiX {
	padding-left: 10px !important;
}

.Shared_mL10__czoFu {
	margin-left: 10px !important;
}

.Shared_pL5__tzpBZ {
	padding-left: 5px !important;
}

.Shared_mL5__HOgZM {
	margin-left: 5px !important;
}

.Shared_pR10__17LLK {
	padding-right: 10px !important;
}

.Shared_mR10__F\\+fUB {
	margin-right: 10px !important;
}

.Shared_pR5__Wz7zU {
	padding-right: 5px !important;
}

.Shared_mR5__vbiCK {
	margin-right: 5px !important;
}

.Shared_mRA__kL8tq {
	margin-right: auto !important;
}

.Shared_mLA__RemlF {
	margin-left: auto !important;
}

.Shared_mTA__\\+H15x {
	margin-top: auto !important;
}

.Shared_mBA__e79rb {
	margin-bottom: auto !important;
}

.Shared_g10__lGHMG {
	gap: 10px !important;
}

.Shared_bRad5__V90Mt {
	border-radius: 5px !important;
}

.Shared_bRad10__W3KBz {
	border-radius: 10px !important;
}

.Shared_pX10__J-17d {
	padding-left: 10px !important;
	padding-right: 10px !important;
}

.Shared_pY10__oLQbi {
	padding-top: 10px !important;
	padding-bottom: 10px !important;
}

.Shared_pX5__xetgT {
	padding-left: 5px !important;
	padding-right: 5px !important;
}

.Shared_pY5__\\+PwxU {
	padding-top: 5px !important;
	padding-bottom: 5px !important;
}

.Shared_wMax__nSA7T {
	width: 100% !important;
}

.Shared_hMax__S0c4w {
	height: 100% !important;
}

.Shared_vWMax__JUojq {
	width: 100vw !important;
}

.Shared_vHMax__KyhM3 {
	height: 100vh !important;
}

.Shared_w50__W5yYs {
	width: 50% !important;
}

.Shared_w48__zQR08 {
	width: 48% !important;
}

.Shared_h50__PA2cN {
	height: 50% !important;
}

.Shared_dInlineBlock__G4uq- {
	display: inline-block !important;
}

.Shared_flex__6U13D {
	display: flex !important;
	flex-wrap: wrap !important;
}

.Shared_flex_nowrap__BDMNK {
	flex-wrap: nowrap !important;
}

.Shared_flex_dColumn__xeMg3 {
	flex-direction: column !important;
}

.Shared_flexCenter__Rw6cT {
	justify-content: center !important;
	align-items: center !important;
}

.Shared_flexStart__PkH8e {
	justify-content: flex-start !important;
	align-items: flex-start !important;
}

.Shared_flexEnd__fghca {
	justify-content: flex-end !important;
	align-items: flex-end !important;
}

.Shared_flexLeft__4tJ3v {
	justify-content: flex-start !important;
	align-items: center !important;
}

.Shared_flexRight__drD4M {
	justify-content: flex-end !important;
	align-items: center !important;
}

.Shared_flexTop__boz1f {
	justify-content: center !important;
	align-items: flex-start !important;
}

.Shared_flexBottom__b6wNy {
	justify-content: center !important;
	align-items: flex-end !important;
}

.Shared_spaceXBetween__XZ6SI {
	justify-content: space-between !important;
}

.Shared_spaceYBetween__AB7ki {
	align-items: space-between !important;
}

.Shared_spaceYStart__m8qaL {
	align-items: flex-start !important;
}

.Shared_spaceYEnd__A00cx {
	align-items: flex-end !important;
}

.Shared_spaceXAround__8H2KL {
	justify-content: space-around !important;
}

.Shared_spaceYAround__sQObL {
	align-items: space-around !important;
}

.Shared_spaceYCenter__qu0vw {
	align-items: center !important;
}

.Shared_spaceXEvenly__jMuko {
	justify-content: space-evenly !important;
}

.Shared_spaceYEvenly__\\+QRtH {
	align-items: space-evenly !important;
}

.Shared_g5__UlPY5 {
	gap: 5px !important;
}

.Shared_g10__lGHMG {
	gap: 10px !important;
}

.Shared_tCenter__A\\+AY9 {
	text-align: center !important;
}

.Shared_tLeft__Tx85q {
	text-align: left !important;
}

.Shared_tRight__p0FO4 {
	text-align: right !important;
}

.Shared_flexOne__WpaGn {
	flex: 1 1 !important;
}

.Shared_pointer__8ZhTp {
	cursor: pointer !important;
}

.Shared_pointerDisabled__4Z6jt {
	cursor: not-allowed !important;
}

.Shared_pointerWaiting__4MR3S {
	cursor: wait !important;
}

.Shared_pointerInProgress__Flhiz {
	cursor: progress !important;
}

.Shared_p_fixed__P2luo {
	position: fixed !important;
}

.Shared_p_relative__WxEGS {
	position: relative !important;
}

.Shared_p_absolute__1dc6d {
	position: absolute !important;
}

.Shared_deck__eWkeP {
	padding-bottom: 50px !important;
}

.Shared_orbitron__Cumb5 {
	font-family: var(--orbitron) !important;
}

.Shared_black__bRp7c {
	color: var(--black) !important;
}

.Shared_lemon__Hp\\+eW {
	color: var(--lemon) !important;
}

.Shared_blue__ZT7wI {
	color: var(--blue) !important;
}

.Shared_peach__nGXi5 {
	color: var(--peach) !important;
}

.Shared_yellow__7YyqZ {
	color: var(--yellow) !important;
}

.Shared_hWAccel__TFm0d {
	-webkit-backface-visibility: hidden;
	-webkit-perspective: 1000;
	-webkit-transform: translate3d(0, 0, 0);
	-webkit-transform: translateZ(0);
	backface-visibility: hidden;
	perspective: 1000;
	transform: translate3d(0, 0, 0);
	transform: translateZ(0);
}

.Shared_link__9BPux {
	color: #141414 !important;
	font-family: Manrope !important;
	font-size: 14px !important;
	font-style: normal !important;
	font-weight: 400 !important;
	line-height: 22px !important;
	text-decoration-line: underline !important;
}

.Shared_shadow__DSEBl:hover {
	box-shadow: 0px 18px 30px 0px rgba(131, 119, 198, 0.11) !important;
}

.Shared_bgWhite__1ITS\\+ {
	background-color: var(--white) !important;
}

.Shared_red__U5hUZ {
	color: #e41d1d !important;
}

.Shared_purple__KUOa3 {
	color: #052E26 !important;
}

.Shared_bNone__OjHZr {
	border: none !important;
}

.Shared_tOverflowEllipsis__UPKZq{
	text-overflow: ellipsis !important;
	overflow: hidden !important;
	white-space: nowrap !important;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 900px) and (min-width: 761px) {
	.Shared_container__W1B98 {
		padding: 10px 50px !important;
	}

	.Shared_w900_100__bfaxm {
		width: 100% !important;
	}

	.Shared_w900_50__NX-vB {
		width: 50% !important;
	}

	.Shared_p900_x20__WxnWZ {
		padding-right: 20px !important;
		padding-left: 20px !important;
	}
}

@media only screen and (max-width: 760px) and (min-width: 481px) {
	.Shared_container__W1B98 {
		padding: 10px 30px !important;
	}

	.Shared_w760_100__qjLMH {
		width: 100% !important;
	}

	.Shared_w760_50__TYk\\+0 {
		width: 50% !important;
	}

	.Shared_p760_x20__lXG1P {
		padding-right: 20px !important;
		padding-left: 20px !important;
	}

	.Shared_p760_x10__hFhA2 {
		padding-right: 10px !important;
		padding-left: 10px !important;
	}
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
	.Shared_container__W1B98 {
		padding: 10px 10px !important;
	}

	.Shared_w480_100__Q3MW\\+ {
		width: 100% !important;
	}

	.Shared_w480_50__I1FmM {
		width: 50% !important;
	}

	.Shared_p480_y50__S8Bk\\+ {
		padding-top: 50px !important;
		padding-bottom: 50px !important;
	}

	.Shared_p480_x50__GwUtp {
		padding-right: 50px !important;
		padding-left: 50px !important;
	}

	.Shared_p480_x20__NA\\+Mw {
		padding-right: 20px !important;
		padding-left: 20px !important;
	}

	.Shared_p480_x10__Yjk\\+C {
		padding-right: 10px !important;
		padding-left: 10px !important;
	}
}

@media only screen and (max-width: 360px) {
	.Shared_container__W1B98 {
		padding: 5px 5px !important;
	}

	.Shared_w360_100__kET2H {
		width: 100% !important;
	}

	.Shared_p360_y10__nl0A9 {
		padding-top: 10px !important;
		padding-bottom: 10px !important;
	}

	.Shared_p360_x10__T4BwF {
		padding-right: 10px !important;
		padding-left: 10px !important;
	}

	.Shared_p360_y10__nl0A9 {
		padding-top: 10px !important;
		padding-bottom: 10px !important;
	}

	.Shared_p360_x10__T4BwF {
		padding-right: 10px !important;
		padding-left: 10px !important;
	}
}

.Shared_hidden__V58X5 {
	/* background: url(../assets/images/hidden.jpg); */
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	min-height: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Shared.module.css"],"names":[],"mappings":"AAAA;CACC,+BAA+B;CAC/B,mCAAmC;AACpC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;CAC7B,8BAA8B;AAC/B;;AAEA;CACC,4BAA4B;CAC5B,+BAA+B;AAChC;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,2BAA2B;CAC3B,8BAA8B;AAC/B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,wBAAwB;CACxB,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;CAClC,8BAA8B;AAC/B;;AAEA;CACC,sCAAsC;CACtC,kCAAkC;AACnC;;AAEA;CACC,oCAAoC;CACpC,gCAAgC;AACjC;;AAEA;CACC,sCAAsC;CACtC,8BAA8B;AAC/B;;AAEA;CACC,oCAAoC;CACpC,8BAA8B;AAC/B;;AAEA;CACC,kCAAkC;CAClC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;CAClC,gCAAgC;AACjC;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,oBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,mCAAmC;CACnC,yBAAyB;CACzB,uCAAuC;CACvC,gCAAgC;CAChC,2BAA2B;CAC3B,iBAAiB;CACjB,+BAA+B;CAC/B,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;CACzB,+BAA+B;CAC/B,0BAA0B;CAC1B,6BAA6B;CAC7B,2BAA2B;CAC3B,4BAA4B;CAC5B,0CAA0C;AAC3C;;AAEA;CACC,kEAAkE;AACnE;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,kCAAkC;CAClC,2BAA2B;CAC3B,8BAA8B;AAC/B;;AAEA,yDAAyD;AACzD;CACC;EACC,6BAA6B;CAC9B;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;AACD;;AAEA;CACC;EACC,6BAA6B;CAC9B;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;AACD;;AAEA;CACC;EACC,6BAA6B;CAC9B;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,4BAA4B;EAC5B,+BAA+B;CAChC;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,4BAA4B;EAC5B,+BAA+B;CAChC;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;;CAEA;EACC,4BAA4B;EAC5B,+BAA+B;CAChC;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;AACD;;AAEA;CACC,kDAAkD;CAClD,2BAA2B;CAC3B,4BAA4B;CAC5B,sBAAsB;CACtB,mBAAmB;AACpB","sourcesContent":["a {\n\tfont-family: inherit !important;\n\ttext-decoration: inherit !important;\n}\n\n.container {\n\tpadding: 10px 100px !important;\n}\n\n.parent {\n\tpadding-top: 90px !important;\n}\n\n.window {\n\tmin-height: 100vh !important;\n}\n\n.p0 {\n\tpadding: 0 !important;\n}\n\n.m0 {\n\tmargin: 0 !important;\n}\n\n.g0 {\n\tgap: 0 !important;\n}\n\n.p5 {\n\tpadding: 5px !important;\n}\n\n.m5 {\n\tmargin: 5px !important;\n}\n\n.g5 {\n\tgap: 5px !important;\n}\n\n.p10 {\n\tpadding: 10px !important;\n}\n\n.pT70 {\n\tpadding-top: 70px !important;\n}\n\n.m10 {\n\tmargin: 10px !important;\n}\n\n.mT70 {\n\tmargin-top: 70px !important;\n}\n\n.pT10 {\n\tpadding-top: 10px !important;\n}\n\n.mT10 {\n\tmargin-top: 10px !important;\n}\n\n.mT20 {\n\tmargin-top: 20px !important;\n}\n\n.pT5 {\n\tpadding-top: 5px !important;\n}\n\n.mT5 {\n\tmargin-top: 5px !important;\n}\n\n.pB10 {\n\tpadding-bottom: 10px !important;\n}\n\n.mB10 {\n\tmargin-bottom: 10px !important;\n}\n\n.pB5 {\n\tpadding-bottom: 5px !important;\n}\n\n.mB5 {\n\tmargin-bottom: 5px !important;\n}\n\n.pL10 {\n\tpadding-left: 10px !important;\n}\n\n.mL10 {\n\tmargin-left: 10px !important;\n}\n\n.pL5 {\n\tpadding-left: 5px !important;\n}\n\n.mL5 {\n\tmargin-left: 5px !important;\n}\n\n.pR10 {\n\tpadding-right: 10px !important;\n}\n\n.mR10 {\n\tmargin-right: 10px !important;\n}\n\n.pR5 {\n\tpadding-right: 5px !important;\n}\n\n.mR5 {\n\tmargin-right: 5px !important;\n}\n\n.mRA {\n\tmargin-right: auto !important;\n}\n\n.mLA {\n\tmargin-left: auto !important;\n}\n\n.mTA {\n\tmargin-top: auto !important;\n}\n\n.mBA {\n\tmargin-bottom: auto !important;\n}\n\n.g10 {\n\tgap: 10px !important;\n}\n\n.bRad5 {\n\tborder-radius: 5px !important;\n}\n\n.bRad10 {\n\tborder-radius: 10px !important;\n}\n\n.pX10 {\n\tpadding-left: 10px !important;\n\tpadding-right: 10px !important;\n}\n\n.pY10 {\n\tpadding-top: 10px !important;\n\tpadding-bottom: 10px !important;\n}\n\n.pX5 {\n\tpadding-left: 5px !important;\n\tpadding-right: 5px !important;\n}\n\n.pY5 {\n\tpadding-top: 5px !important;\n\tpadding-bottom: 5px !important;\n}\n\n.wMax {\n\twidth: 100% !important;\n}\n\n.hMax {\n\theight: 100% !important;\n}\n\n.vWMax {\n\twidth: 100vw !important;\n}\n\n.vHMax {\n\theight: 100vh !important;\n}\n\n.w50 {\n\twidth: 50% !important;\n}\n\n.w48 {\n\twidth: 48% !important;\n}\n\n.h50 {\n\theight: 50% !important;\n}\n\n.dInlineBlock {\n\tdisplay: inline-block !important;\n}\n\n.flex {\n\tdisplay: flex !important;\n\tflex-wrap: wrap !important;\n}\n\n.flex_nowrap {\n\tflex-wrap: nowrap !important;\n}\n\n.flex_dColumn {\n\tflex-direction: column !important;\n}\n\n.flexCenter {\n\tjustify-content: center !important;\n\talign-items: center !important;\n}\n\n.flexStart {\n\tjustify-content: flex-start !important;\n\talign-items: flex-start !important;\n}\n\n.flexEnd {\n\tjustify-content: flex-end !important;\n\talign-items: flex-end !important;\n}\n\n.flexLeft {\n\tjustify-content: flex-start !important;\n\talign-items: center !important;\n}\n\n.flexRight {\n\tjustify-content: flex-end !important;\n\talign-items: center !important;\n}\n\n.flexTop {\n\tjustify-content: center !important;\n\talign-items: flex-start !important;\n}\n\n.flexBottom {\n\tjustify-content: center !important;\n\talign-items: flex-end !important;\n}\n\n.spaceXBetween {\n\tjustify-content: space-between !important;\n}\n\n.spaceYBetween {\n\talign-items: space-between !important;\n}\n\n.spaceYStart {\n\talign-items: flex-start !important;\n}\n\n.spaceYEnd {\n\talign-items: flex-end !important;\n}\n\n.spaceXAround {\n\tjustify-content: space-around !important;\n}\n\n.spaceYAround {\n\talign-items: space-around !important;\n}\n\n.spaceYCenter {\n\talign-items: center !important;\n}\n\n.spaceXEvenly {\n\tjustify-content: space-evenly !important;\n}\n\n.spaceYEvenly {\n\talign-items: space-evenly !important;\n}\n\n.g5 {\n\tgap: 5px !important;\n}\n\n.g10 {\n\tgap: 10px !important;\n}\n\n.tCenter {\n\ttext-align: center !important;\n}\n\n.tLeft {\n\ttext-align: left !important;\n}\n\n.tRight {\n\ttext-align: right !important;\n}\n\n.flexOne {\n\tflex: 1 !important;\n}\n\n.pointer {\n\tcursor: pointer !important;\n}\n\n.pointerDisabled {\n\tcursor: not-allowed !important;\n}\n\n.pointerWaiting {\n\tcursor: wait !important;\n}\n\n.pointerInProgress {\n\tcursor: progress !important;\n}\n\n.p_fixed {\n\tposition: fixed !important;\n}\n\n.p_relative {\n\tposition: relative !important;\n}\n\n.p_absolute {\n\tposition: absolute !important;\n}\n\n.deck {\n\tpadding-bottom: 50px !important;\n}\n\n.orbitron {\n\tfont-family: var(--orbitron) !important;\n}\n\n.black {\n\tcolor: var(--black) !important;\n}\n\n.lemon {\n\tcolor: var(--lemon) !important;\n}\n\n.blue {\n\tcolor: var(--blue) !important;\n}\n\n.peach {\n\tcolor: var(--peach) !important;\n}\n\n.yellow {\n\tcolor: var(--yellow) !important;\n}\n\n.hWAccel {\n\t-webkit-backface-visibility: hidden;\n\t-webkit-perspective: 1000;\n\t-webkit-transform: translate3d(0, 0, 0);\n\t-webkit-transform: translateZ(0);\n\tbackface-visibility: hidden;\n\tperspective: 1000;\n\ttransform: translate3d(0, 0, 0);\n\ttransform: translateZ(0);\n}\n\n.link {\n\tcolor: #141414 !important;\n\tfont-family: Manrope !important;\n\tfont-size: 14px !important;\n\tfont-style: normal !important;\n\tfont-weight: 400 !important;\n\tline-height: 22px !important;\n\ttext-decoration-line: underline !important;\n}\n\n.shadow:hover {\n\tbox-shadow: 0px 18px 30px 0px rgba(131, 119, 198, 0.11) !important;\n}\n\n.bgWhite {\n\tbackground-color: var(--white) !important;\n}\n\n.red {\n\tcolor: #e41d1d !important;\n}\n\n.purple {\n\tcolor: #052E26 !important;\n}\n\n.bNone {\n\tborder: none !important;\n}\n\n.tOverflowEllipsis{\n\ttext-overflow: ellipsis !important;\n\toverflow: hidden !important;\n\twhite-space: nowrap !important;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 900px) and (min-width: 761px) {\n\t.container {\n\t\tpadding: 10px 50px !important;\n\t}\n\n\t.w900_100 {\n\t\twidth: 100% !important;\n\t}\n\n\t.w900_50 {\n\t\twidth: 50% !important;\n\t}\n\n\t.p900_x20 {\n\t\tpadding-right: 20px !important;\n\t\tpadding-left: 20px !important;\n\t}\n}\n\n@media only screen and (max-width: 760px) and (min-width: 481px) {\n\t.container {\n\t\tpadding: 10px 30px !important;\n\t}\n\n\t.w760_100 {\n\t\twidth: 100% !important;\n\t}\n\n\t.w760_50 {\n\t\twidth: 50% !important;\n\t}\n\n\t.p760_x20 {\n\t\tpadding-right: 20px !important;\n\t\tpadding-left: 20px !important;\n\t}\n\n\t.p760_x10 {\n\t\tpadding-right: 10px !important;\n\t\tpadding-left: 10px !important;\n\t}\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n\t.container {\n\t\tpadding: 10px 10px !important;\n\t}\n\n\t.w480_100 {\n\t\twidth: 100% !important;\n\t}\n\n\t.w480_50 {\n\t\twidth: 50% !important;\n\t}\n\n\t.p480_y50 {\n\t\tpadding-top: 50px !important;\n\t\tpadding-bottom: 50px !important;\n\t}\n\n\t.p480_x50 {\n\t\tpadding-right: 50px !important;\n\t\tpadding-left: 50px !important;\n\t}\n\n\t.p480_x20 {\n\t\tpadding-right: 20px !important;\n\t\tpadding-left: 20px !important;\n\t}\n\n\t.p480_x10 {\n\t\tpadding-right: 10px !important;\n\t\tpadding-left: 10px !important;\n\t}\n}\n\n@media only screen and (max-width: 360px) {\n\t.container {\n\t\tpadding: 5px 5px !important;\n\t}\n\n\t.w360_100 {\n\t\twidth: 100% !important;\n\t}\n\n\t.p360_y10 {\n\t\tpadding-top: 10px !important;\n\t\tpadding-bottom: 10px !important;\n\t}\n\n\t.p360_x10 {\n\t\tpadding-right: 10px !important;\n\t\tpadding-left: 10px !important;\n\t}\n\n\t.p360_y10 {\n\t\tpadding-top: 10px !important;\n\t\tpadding-bottom: 10px !important;\n\t}\n\n\t.p360_x10 {\n\t\tpadding-right: 10px !important;\n\t\tpadding-left: 10px !important;\n\t}\n}\n\n.hidden {\n\t/* background: url(../assets/images/hidden.jpg); */\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tmin-height: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Shared_container__W1B98`,
	"parent": `Shared_parent__yPy3i`,
	"window": `Shared_window__2hIRZ`,
	"p0": `Shared_p0__zxx2s`,
	"m0": `Shared_m0__-P+BZ`,
	"g0": `Shared_g0__Kx7-c`,
	"p5": `Shared_p5__jCU7D`,
	"m5": `Shared_m5__Nxq3r`,
	"g5": `Shared_g5__UlPY5`,
	"p10": `Shared_p10__swOie`,
	"pT70": `Shared_pT70__H56L8`,
	"m10": `Shared_m10__P7A8Z`,
	"mT70": `Shared_mT70__IWcDj`,
	"pT10": `Shared_pT10__BnsvV`,
	"mT10": `Shared_mT10__zjjBt`,
	"mT20": `Shared_mT20__IfbQA`,
	"pT5": `Shared_pT5__v7BKz`,
	"mT5": `Shared_mT5__9GviX`,
	"pB10": `Shared_pB10__lfo0d`,
	"mB10": `Shared_mB10__SXkVD`,
	"pB5": `Shared_pB5__tbweH`,
	"mB5": `Shared_mB5__jMOZ1`,
	"pL10": `Shared_pL10__nHCiX`,
	"mL10": `Shared_mL10__czoFu`,
	"pL5": `Shared_pL5__tzpBZ`,
	"mL5": `Shared_mL5__HOgZM`,
	"pR10": `Shared_pR10__17LLK`,
	"mR10": `Shared_mR10__F+fUB`,
	"pR5": `Shared_pR5__Wz7zU`,
	"mR5": `Shared_mR5__vbiCK`,
	"mRA": `Shared_mRA__kL8tq`,
	"mLA": `Shared_mLA__RemlF`,
	"mTA": `Shared_mTA__+H15x`,
	"mBA": `Shared_mBA__e79rb`,
	"g10": `Shared_g10__lGHMG`,
	"bRad5": `Shared_bRad5__V90Mt`,
	"bRad10": `Shared_bRad10__W3KBz`,
	"pX10": `Shared_pX10__J-17d`,
	"pY10": `Shared_pY10__oLQbi`,
	"pX5": `Shared_pX5__xetgT`,
	"pY5": `Shared_pY5__+PwxU`,
	"wMax": `Shared_wMax__nSA7T`,
	"hMax": `Shared_hMax__S0c4w`,
	"vWMax": `Shared_vWMax__JUojq`,
	"vHMax": `Shared_vHMax__KyhM3`,
	"w50": `Shared_w50__W5yYs`,
	"w48": `Shared_w48__zQR08`,
	"h50": `Shared_h50__PA2cN`,
	"dInlineBlock": `Shared_dInlineBlock__G4uq-`,
	"flex": `Shared_flex__6U13D`,
	"flex_nowrap": `Shared_flex_nowrap__BDMNK`,
	"flex_dColumn": `Shared_flex_dColumn__xeMg3`,
	"flexCenter": `Shared_flexCenter__Rw6cT`,
	"flexStart": `Shared_flexStart__PkH8e`,
	"flexEnd": `Shared_flexEnd__fghca`,
	"flexLeft": `Shared_flexLeft__4tJ3v`,
	"flexRight": `Shared_flexRight__drD4M`,
	"flexTop": `Shared_flexTop__boz1f`,
	"flexBottom": `Shared_flexBottom__b6wNy`,
	"spaceXBetween": `Shared_spaceXBetween__XZ6SI`,
	"spaceYBetween": `Shared_spaceYBetween__AB7ki`,
	"spaceYStart": `Shared_spaceYStart__m8qaL`,
	"spaceYEnd": `Shared_spaceYEnd__A00cx`,
	"spaceXAround": `Shared_spaceXAround__8H2KL`,
	"spaceYAround": `Shared_spaceYAround__sQObL`,
	"spaceYCenter": `Shared_spaceYCenter__qu0vw`,
	"spaceXEvenly": `Shared_spaceXEvenly__jMuko`,
	"spaceYEvenly": `Shared_spaceYEvenly__+QRtH`,
	"tCenter": `Shared_tCenter__A+AY9`,
	"tLeft": `Shared_tLeft__Tx85q`,
	"tRight": `Shared_tRight__p0FO4`,
	"flexOne": `Shared_flexOne__WpaGn`,
	"pointer": `Shared_pointer__8ZhTp`,
	"pointerDisabled": `Shared_pointerDisabled__4Z6jt`,
	"pointerWaiting": `Shared_pointerWaiting__4MR3S`,
	"pointerInProgress": `Shared_pointerInProgress__Flhiz`,
	"p_fixed": `Shared_p_fixed__P2luo`,
	"p_relative": `Shared_p_relative__WxEGS`,
	"p_absolute": `Shared_p_absolute__1dc6d`,
	"deck": `Shared_deck__eWkeP`,
	"orbitron": `Shared_orbitron__Cumb5`,
	"black": `Shared_black__bRp7c`,
	"lemon": `Shared_lemon__Hp+eW`,
	"blue": `Shared_blue__ZT7wI`,
	"peach": `Shared_peach__nGXi5`,
	"yellow": `Shared_yellow__7YyqZ`,
	"hWAccel": `Shared_hWAccel__TFm0d`,
	"link": `Shared_link__9BPux`,
	"shadow": `Shared_shadow__DSEBl`,
	"bgWhite": `Shared_bgWhite__1ITS+`,
	"red": `Shared_red__U5hUZ`,
	"purple": `Shared_purple__KUOa3`,
	"bNone": `Shared_bNone__OjHZr`,
	"tOverflowEllipsis": `Shared_tOverflowEllipsis__UPKZq`,
	"w900_100": `Shared_w900_100__bfaxm`,
	"w900_50": `Shared_w900_50__NX-vB`,
	"p900_x20": `Shared_p900_x20__WxnWZ`,
	"w760_100": `Shared_w760_100__qjLMH`,
	"w760_50": `Shared_w760_50__TYk+0`,
	"p760_x20": `Shared_p760_x20__lXG1P`,
	"p760_x10": `Shared_p760_x10__hFhA2`,
	"w480_100": `Shared_w480_100__Q3MW+`,
	"w480_50": `Shared_w480_50__I1FmM`,
	"p480_y50": `Shared_p480_y50__S8Bk+`,
	"p480_x50": `Shared_p480_x50__GwUtp`,
	"p480_x20": `Shared_p480_x20__NA+Mw`,
	"p480_x10": `Shared_p480_x10__Yjk+C`,
	"w360_100": `Shared_w360_100__kET2H`,
	"p360_y10": `Shared_p360_y10__nl0A9`,
	"p360_x10": `Shared_p360_x10__T4BwF`,
	"hidden": `Shared_hidden__V58X5`
};
export default ___CSS_LOADER_EXPORT___;
